import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PageNotFound from '../PageNotFound';
import './Layout.css';
import TermsAndConditions from '../TermsAndConditions';
import PrivacyPolicy from '../PrivacyPolicy';
import Cookies from '../Cookies';
import About from '../About';
import NavMenu from './NavMenu';
import Contact from '../Contact';

function InfoLayout(
    {
        user,
        history,
        ...props
    }
) {

    useEffect(() => {
       
    }, [])


    return (
        <React.Fragment>
            <nav className="col-md-3 ml-sm-auto col-lg-2 d-none d-md-block bg-light sidebar">
                <div className="sidebar-sticky">
                    <Switch>
                        <Route path='/about' component={() => <NavMenu hideProfileLink={true} hideAboutLink={true} />} />
                    </Switch>
                </div>
            </nav> 
            <div className="container-fluid h-100">
                <main role="main" className="h-100 col-md-9 ml-sm-auto col-lg-10">
                    <Switch>
                        <Route path='/about/termsandconditions' component={TermsAndConditions} />
                        <Route path='/about/privacypolicy' component={PrivacyPolicy} />
                        <Route path='/about/cookies' component={Cookies} />
                        <Route path='/about/contact' component={Contact} />
                        <Route path='/about' component={About} />
                        <Route component={PageNotFound} />
                    </Switch>
                </main>
            </div>
        </React.Fragment>
    );
}


InfoLayout.propTypes =
{
    user: PropTypes.object,
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoLayout);






// WEBPACK FOOTER //
// ./src/components/common/InfoLayout.js